<div [ngSwitch]="studySettingVariable.dataTypeCode">
    <!-- Categorical Type -->
    <div *ngSwitchCase="'C'">
        <!-- Non-Breeding Method Case -->
        <ng-container *ngIf="!isBreedingMethod()">
            <ng-select name="categoricalDropdown" id="categoricalDropdown"
                       [items]="categoricalItems"
                       [(ngModel)]="studySettingVariable.value"
                       bindLabel="description"
                       bindValue="id"
                       class="ng-select-inline-edit"
                       [clearable]="true"
                       [searchable]="false"
                       (blur)="handleBlur()"
                       (keydown)="handleKeyDown($event)"
                       dropdownPosition="bottom"
                       #inputElement>
            </ng-select>
        </ng-container>

        <ng-container *ngIf="isBreedingMethod()">
            <jhi-breeding-methods-select [selectWidth]="'100%'"
                                         [showAllMethodTypesOption]="false"
                                         [showDerivativeMethodTypesOption]="false"
                                         [showGenerativeMethodTypesOption]="false"
                                         [breedingMethodFilterTypeValue]="BreedingMethodFilterTypeEnum.ALL_METHODS"
                                         [showFavoritesCheckbox]="false"
                                         [customClass]="'ng-select-inline-edit'"
                                         (blur)="handleBlur()"
                                         (keyDown)="handleKeyDown($event)"
                                         (onMethodChanged)="onMethodChanged($event)"
            ></jhi-breeding-methods-select>
        </ng-container>
    </div>

    <!-- Numeric Type -->
    <div *ngSwitchCase="'N'">
        <input type="number"
               class="number-input"
               [(ngModel)]="studySettingVariable.value"
               (blur)="handleBlur()"
               (keydown)="handleKeyDown($event)"
               #inputElement>
    </div>

    <!-- Text Type -->
    <div *ngSwitchCase="'T'">
        <input type="text"
               class="text-input"
               maxlength="255"
               [(ngModel)]="studySettingVariable.value"
               (blur)="handleBlur()"
               (keydown)="handleKeyDown($event)"
               #inputElement>
    </div>

    <!-- Date Type -->
    <div *ngSwitchCase="'D'" class="d-flex">
            <input class="form-control date-input"
                   [placeholder]="'global.date.no.dash.placeholder' | translate"
                   [(ngModel)]="studySettingVariable.value"
                   [placement]="'auto'"
                   [container]="'body'"
                   [autoClose]="true"
                   (keydown)="handleKeyDown($event)"
                   (dateSelect)="handleBlur()"
                   ngbDatepicker #inputElement #datepicker="ngbDatepicker">
            <div class="justify-content-end">
                <button class="btn btn-sm btn-outline-secondary calendar" (click)="datepicker.toggle()"
                        type="button"><i class="fa fa-calendar"></i></button>
            </div>
    </div>
</div>
